
document.addEventListener("DOMContentLoaded", function () {
  const contentContainer = document.querySelector('.article-template__content');
  const headings = contentContainer.querySelectorAll('h2');
  if (headings.length === 0) return;

  const tocContainer = document.createElement('div');
  tocContainer.id = 'toc-container';
  tocContainer.innerHTML = '<h2>Table of Contents</h2><ul id="toc-list"></ul>';
  const tocList = tocContainer.querySelector('#toc-list');

  headings.forEach(function (heading) {
    let id = heading.innerText
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '');

    heading.setAttribute('id', id);

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('href', '#' + id);
    a.textContent = heading.innerText;

    a.addEventListener('click', function (e) {
      e.preventDefault();

      const target = document.getElementById(id);
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Update URL hash without jumping
      history.pushState(null, '', '#' + id);
    });

    li.appendChild(a);
    tocList.appendChild(li);
  });

  contentContainer.insertBefore(tocContainer, headings[0]);
});

